function ToolCard({ className = 'tool', icon, iconElement, iconClassName = 'iconImage', title, meta, onClick, actions }) {
    const content = (
        <>
            <div className='icon'>
                {iconElement || <img src={icon} className={iconClassName} alt='' />}
            </div>
            <div className='toolname'>
                <span>{title}</span>
                {meta}
            </div>
        </>
    );

    return (
        <div className={className} onClick={onClick}>
            {className === 'favtool' ? <div className='favToolLeft'>{content}</div> : content}
            {actions}
        </div>
    );
}

export default ToolCard;
